export const BACKGROUND_EVENTS = {
  INIT: 'init',
  UPDATE: 'update',
  FORCE_UPDATE: 'forceUpdate',
};